// extracted by mini-css-extract-plugin
export var chevron = "_2k-2";
export var chevronCollapsed = "_2k-3";
export var collapsibleHeader = "_2k-1";
export var container = "_2k-0";